import {useTranslation} from "react-i18next";
import React, {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import IdentityImage from "../../components/IdentityImage.jsx";
import ImageCropperModal from "../../components/cropper/ImageCropperModal.jsx";
import Button from "../../components/Button.jsx";
import useDownloadState from "../../api/utilities/useDownloadState.js";
import {ProjectApi} from "../../api/authority/generated/index.ts";
import toast from "react-hot-toast";

export default function ProjectProfileLogo({project}) {

    let {t} = useTranslation();
    let [visible, setVisible] = useState(false);
    let {getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);

    let [uploadImageBlob, setUploadImageBlob] = useState(null)
    let [state, setDownloading, setResult, setError] = useDownloadState();

    useEffect(() => {
        if (!visible) {
            setResult(null);
            setError(null);
        }
    }, [visible]);

    useEffect(() => {
        if (uploadImageBlob === null) {
            return;
        }

        setUploadImageBlob(null);
        setDownloading(true);

        setTimeout(() => {
            new ProjectApi(getAuthorityConfiguration())
                .uploadLogo({
                    projectId: project.id,
                    logo: uploadImageBlob,
                })
                .then((r) => {
                    toast.success(t('project.logo-uploaded'));
                    setVisible(false);
                    resetCurrentUserProjects();
                })
                .catch((e) => setError(e))
                .finally(() => setDownloading(false));
        }, 150);


    }, [uploadImageBlob]);

    return (
        <>
            <ImageCropperModal
                title={t('project.change-logo')}
                visible={visible}
                setVisible={setVisible}
                loading={state.downloading}
                error={state.error}
                onSubmit={(blob) => {
                    setUploadImageBlob(blob);
                }}
            />
            <section>
                <div className="flex items-center">
                    <div className="mr-4">
                        <IdentityImage
                            large={true}
                            url={project.logoUrl}
                            project={project}
                        />
                    </div>
                    <div>
                        <Button variant="outline-black" onClick={() => setVisible(true)}>
                            {t('project.change-logo')}
                        </Button>
                    </div>
                </div>
            </section>
        </>
    );
}
